import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { CampaignFormInput } from './schema'

export function CampaignIntegrations() {
  const form = useFormContext<CampaignFormInput>()

  return (
    <>
      {/* Integração Guru */}
      <div className="space-y-3 rounded-lg border bg-muted/40 p-4">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">Integração Guru</h3>
          <span className="rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-semibold text-blue-800">
            Guru
          </span>
        </div>

        <FormField
          control={form.control}
          name="maxSubscriptionCycles"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Limite de Ciclos (Assinaturas)</FormLabel>
              <FormControl>
                <Input
                  className="bg-background"
                  type="number"
                  placeholder="Ex: 1 (apenas 1º ciclo)"
                  {...field}
                  value={field.value ?? ''}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              </FormControl>
              <FormDescription className="text-xs">
                Define em quantos ciclos (pedidos) o desconto será aplicado.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Integração Yampi */}
      <div className="space-y-3 rounded-lg border bg-muted/40 p-4">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">Integração Yampi</h3>
          <span className="rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-semibold text-orange-800">
            Yampi
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <FormField
            control={form.control}
            name="yampiOncePerCustomer"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Uso único por cliente</FormLabel>
                <Select
                  onValueChange={(val) => field.onChange(val === 'true')}
                  value={field.value ? 'true' : 'false'}
                >
                  <FormControl>
                    <SelectTrigger className="bg-background">
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectItem value="true">Sim (1 uso por CPF)</SelectItem>
                    <SelectItem value="false">Não (Ilimitado por CPF)</SelectItem>
                  </SelectContent>
                </Select>
                <FormDescription className="text-xs">
                  Limita o uso do cupom a 1x por cliente.
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="yampiAccumulate"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Acumular Promoções</FormLabel>
                <Select
                  onValueChange={(val) => field.onChange(val === 'true')}
                  value={field.value ? 'true' : 'false'}
                >
                  <FormControl>
                    <SelectTrigger className="bg-background">
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectItem value="true">Sim (Permitir)</SelectItem>
                    <SelectItem value="false">Não (Bloquear)</SelectItem>
                  </SelectContent>
                </Select>
                <FormDescription className="text-xs">
                  Permite usar junto com outros descontos.
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="yampiIgnorePromotionProducts"
            render={({ field }) => (
              <FormItem className="sm:col-span-2">
                <FormLabel>Ignorar Produtos em Oferta</FormLabel>
                <Select
                  onValueChange={(val) => field.onChange(val === 'true')}
                  value={field.value ? 'true' : 'false'}
                >
                  <FormControl>
                    <SelectTrigger className="bg-background">
                      <SelectValue placeholder="Selecione" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectItem value="true">Sim (Cupom não aplica em ofertas)</SelectItem>
                    <SelectItem value="false">Não (Aplica mesmo em ofertas)</SelectItem>
                  </SelectContent>
                </Select>
                <FormDescription className="text-xs">
                  Se "Sim", produtos que já têm desconto (de/por) não receberão o desconto do cupom.
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </>
  )
}
